module.exports = __webpack_public_path__ + "media/arek3.45631be2.mp3";